import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
console.log("modules",modules);
const store = new Vuex.Store({
  modules,
  getters,
  // state: {
  //   // dialogValue: false, // 地图下方按钮点击后出现的弹框的显示隐藏
  //   // dialogSrc: '', // 弹窗iframe链接
  //   // iframeDom: '',
  // },
  // getters: {},
  // mutations: {
  //   // // 关闭弹窗
  //   // closeDialog(state) {
  //   //   state.dialogValue = false
  //   //   state.dialogSrc = ''
  //   // },
  //   // // 打开弹窗
  //   // openDialog(state) {
  //   //   state.dialogValue = true
  //   // },
  //   // // 更新弹窗链接
  //   // updateDialogSrc(state, url) {
  //   //   state.dialogSrc = url
  //   // },
  //   // // 储存iframeDom
  //   // updateiframeDom(state, iframe) {
  //   //   state.iframeDom = iframe
  //   // },
  // },
})

export default store
